import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateService} from "../../services/template.service";
import {ApiService} from "../../services/api.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {SubSink} from "subsink";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {SelectItem} from "primeng/api";
import {CALENDAR_LOCALE} from "../../services/constant";
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import * as moment from "moment";
import {HttpParams} from "@angular/common/http";
import {DownloadService} from "../download/download.service";

@Component({
  selector: 'app-document-request-dashboard',
  templateUrl: './document-request-dashboard.component.html',
  styleUrls: ['./document-request-dashboard.component.scss'],
  providers:[TemplateService],

})
export class DocumentRequestDashboardComponent implements OnInit,OnDestroy {

    private subs = new SubSink();
  modal: NgbModalRef;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems: number = 0 ;
  transactions_approve:any;
  transactions_rejected:any;
  transactions_pending:any;
  transactions_not_sent:any;
  ApproveChart: Chart;
  RejectedChart: Chart;
  pendingChart: Chart;
  clearChart: Chart;
  emailTotal;
  data;
  docType;
  myChart1;
  myChart2;
  myChart3;
  myChart4;
  loading;
  loading_main = false;
  datastatus = [];
  selectedCustomercode =null;
  customercode:any;
  deliverycodeList: any = null;
  selectedDeliverycode: SelectItem[];
  allDeliverycodeList = [];
  company;
  treeTableValue;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  documentType:any;
  allDocumentType:any;
  email:any;
  documentnum:any;
   sortBy = null;
   sortMode = null;
   checkdate = null;
   documentNumber = '';
   documentList = [];
   tableCol = [];
   defaultLabel=  null;
  constructor(private apiService: ApiService,
              private translate: TranslateService,
              private template: TemplateService,
              private downloadService: DownloadService) { }

 ngOnInit() {
    this.loadDataShow();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.getEmailReport();
    // this.loadTexts();
    // this.getDocumentRequestList();

  }

  getEmailReport() {
    this.loading_main = true ;
     this.rdDocumentType = this.template.getDropdown();
      this.data = this.downloadService.getDocumentRequestList().subscribe((res: any) => {
        this.emailTotal = res.count;
        this.transactions_approve = res.approved;
        this.transactions_rejected = res.rejected;
        this.transactions_pending = res.pending;
        this.loading_main = false;
         this.generateChart();
        this.getTreeTableValue();
        this.loadTexts();
      });

  }
  loadTexts(){
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.selectedCustomercode = null;
    this.customercode = null;
    this.selectedRdDocumentType = null;
    this.customercode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.downloadService.getDocumentRequestList().subscribe(
      (result) => {
        _.forEach(result.results, (obj) => {
          this.customercode.push({
            label: obj.customer_code,
            value: obj.customer_code
          })
        });
      },
      error => error(status)
    );


    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
  }

  getTreeTableValue() {
    this.treeTableValue = {
      'data':
        [
          {
            'data': {
              'name': 'Documents',
              'size': '75kb',
              'type': 'Folder'
            },
            'children': [
              {
                'data': {
                  'name': 'Work',
                  'size': '55kb',
                  'type': 'Folder'
                },
                'children': [
                  {
                    'data': {
                      'name': 'Expenses.doc',
                      'size': '30kb',
                      'type': 'Document'
                    }
                  },
                  {
                    'data': {
                      'name': 'Resume.doc',
                      'size': '25kb',
                      'type': 'Resume'
                    }
                  }
                ]
              },
              {
                'data': {
                  'name': 'Home',
                  'size': '20kb',
                  'type': 'Folder'
                },
                'children': [
                  {
                    'data': {
                      'name': 'Invoices',
                      'size': '20kb',
                      'type': 'Text'
                    }
                  }
                ]
              }
            ]
          },
          {
            'data': {
              'name': 'Pictures',
              'size': '150kb',
              'type': 'Folder'
            },
            'children': [
              {
                'data': {
                  'name': 'barcelona.jpg',
                  'size': '90kb',
                  'type': 'Picture'
                }
              },
              {
                'data': {
                  'name': 'primeui.png',
                  'size': '30kb',
                  'type': 'Picture'
                }
              },
              {
                'data': {
                  'name': 'optimus.jpg',
                  'size': '30kb',
                  'type': 'Picture'
                }
              }
            ]
          }
        ]
    };
  }

  generateChart() {
    const keepchart = this.transactions_approve+this.transactions_rejected+this.transactions_pending;
    this.ApproveChart = new Chart('ApproveChart', {
      type: 'doughnut',
      data: {
        // labels: ['Red', 'Blue', 'Yellow'],
        datasets: [{
          label: 'Sent Chart',
          data: [this.transactions_approve,this.emailTotal],
          backgroundColor: [

            '#16c8c8',
            '#5b5a5a',

          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });

    this.RejectedChart = new Chart('RejectedChart', {
      type: 'doughnut',
      data: {
        // labels: ['Red', 'Blue', 'Yellow'],
        datasets: [{
          label: '# of Votes',
     data: [this.transactions_rejected,this.emailTotal],
          backgroundColor: [
            '#FF6384',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    });
     this.pendingChart = new Chart('pendingChart', {
      type: 'doughnut',
      data: {
        // labels: ['Red', 'Blue', 'Yellow'],
        datasets: [{
          label: 'pendingChart',
     data: [this.transactions_pending,this.emailTotal],
          backgroundColor: [
            '#FADA3A',
            '#6F6E6E'
          ],
          borderColor: [
            '#ededed',
            '#ededed',
          ],
          borderWidth: 1
        }]
      },
      options: {
        tooltips: {
          enabled: false,
        },
        cutoutPercentage: 60
      }
    })

  }

  pageChanged() {
      this.getDocumentRequestList(this.currentPage);
  }

  setPageSide() {

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.getDocumentRequestList();
  }
   sentdate(){
    this.checkdate = 1 ;
  }

  getDocumentRequestList(page?) {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
     this.datastatus = [];
    this.loading_main = true;
    let keepstartDate = moment(this.startDate).format('YYYY-MM-DD');
    let keependDate = moment(this.endDate).format('YYYY-MM-DD');
    let params = new HttpParams();
    if (this.selectedCustomercode && this.selectedRdDocumentType ) {
      params = params.append('customer_code', this.selectedCustomercode);
      params = params.append('rd_doc_type', this.selectedRdDocumentType);}
    if(this.selectedCustomercode) {params = params.append('customer_code', this.selectedCustomercode);}
    if(this.selectedRdDocumentType) {params = params.append('rd_doc_type', this.selectedRdDocumentType);}
    if(this.email) {params = params.append('email', this.email);}
    if(this.documentnum) {params = params.append('document_number', this.documentnum);}
    if(this.checkdate == 1 ){
    params = params.append('document_start_date', keepstartDate);
    params = params.append('document_end_date', keependDate);
    }
    params = params.append('page',this.currentPage.toString());
    params = params.append('page_size', this.itemsPerPage.toString());
    this.downloadService.getDocumentRequestList(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.totalItems = result.count;
        this.datastatus.push({
            created_at:obj.created_at,
            customer_code:obj.customer_code,
            document_number:obj.document_number,
            email:obj.email,
            po_number:obj.po_number,
          rd_doc_type_display:obj.rd_doc_type_display,
          rd_doc_type:obj.rd_doc_type,
          request_status:obj.request_status,
          id:obj.id,
          status:obj.status
        });
      });
      this.loading_main = false ;
    });

  }

   loadDataShow(){
    this.datastatus = [];
    this.loading_main = true;
    this.customercode;
    let params = new HttpParams();
    params = params.append('page',this.currentPage.toString())
    params = params.append('page_size', this.itemsPerPage.toString())
    this.downloadService.getDocumentRequestList(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.totalItems = result.count;
        this.datastatus.push({
            created_at:obj.created_at,
            customer_code:obj.customer_code,
            document_number:obj.document_number,
            email:obj.email,
            po_number:obj.po_number,
          rd_doc_type_display:obj.rd_doc_type_display,
          rd_doc_type:obj.rd_doc_type,
          request_status:obj.request_status,
          id:obj.id,
          status:obj.status
        });
      });
      this.loading_main = false ;
    });
  }
   get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (2020) + ':' + (thisYear);
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }
  clearData(){
    this.transactions_rejected = null;
    this.transactions_pending = null;
    this.transactions_not_sent = null;
    this.transactions_approve = null;
    this.datastatus = null;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.rdDocumentType = null;
    this.deliverycodeList = null;
    this.customercode = null;
    this.email = null;
    this.documentnum = null;
    this.startDate = null;
    this.endDate = new Date();
    this.startDate = new Date();
    this.sortBy = null;
    this.sortMode = null;
    this.totalItems  =null;
    this.checkdate = null;
    this.getEmailReport();
    this.loadTexts();
    this.loadDataShow();

  }
  selectedType(data,status){
    this.datastatus = [];
    this.totalItems  =null;
    this.loading_main = true;
    const params = new HttpParams()
      .set('request_status', status);
    this.downloadService.getDocumentRequestList(params).subscribe((result) => {
      _.forEach(result.results, (obj) => {
        this.totalItems = result.count;
        this.datastatus.push({
            created_at:obj.created_at,
            customer_code:obj.customer_code,
            document_number:obj.document_number,
            email:obj.email,
            po_number:obj.po_number,
            rd_doc_type_display:obj.rd_doc_type_display,
            rd_doc_type:obj.rd_doc_type,
            request_status:obj.request_status,
            id:obj.id,
            status:obj.status
        });
      });
    });
    this.loading_main = false ;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard.component.ts